import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { queryKeys, staleTimes } from '../config/queryClient';

/**
 * Hook para obtener las features activas de una sucursal
 * (geolocalización, zona rural, etc.)
 * 
 * @param {number} shopBranchId - ID de la sucursal
 * @param {object} options - Opciones adicionales
 * @returns {object} - { data: features[], isLoading, error }
 */
export const useBranchFeatures = (shopBranchId, options = {}) => {
  return useQuery({
    queryKey: queryKeys.branchFeatures(shopBranchId),
    
    queryFn: async () => {
      const response = await axios.get(
        process.env.REACT_APP_API_FEATURE_SELECTOR_CARTA_ROUTE,
        {
          params: {
            shopBranchId,
          },
        }
      );
      return response.data;
    },
    
    enabled: !!shopBranchId,
    
    // Features raramente cambian
    staleTime: staleTimes.static, // 1 hora
    
    cacheTime: 60 * 60 * 1000, // 1 hora
    
    ...options,
  });
};

/**
 * Hook helper para verificar si una feature específica está activa
 */
export const useIsFeatureActive = (shopBranchId, featureName) => {
  const { data: features = [] } = useBranchFeatures(shopBranchId);
  
  const feature = features.find(
    (f) => f.name === featureName && f.status === true
  );
  
  return !!feature;
};
